export const optionsForReportStatus: Array<string> = [
  'pending',
  'processing',
  'generated',
  'uploaded',
  'retrying_upload',
  'failed',
];

export const optionsForReportType: Array<string> = [
  'S3ReportEntity',
  'sharepointReportEntity',
  'webDavReportEntity',
];

export const optionsForReportLocale: Array<string> = ['de', 'en'];
